
import * as React from 'react';

import { library } from '@fortawesome/fontawesome-svg-core'
import {faDownload, faMinus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faDownload, faMinus)

import { findDOMNode } from 'react-dom';
import { downloadTemplate, ITemplate, TEMPLATE_DROPZONES, TemplateHolder } from '../logic/templates';
import './style.css';

interface ITemplateEntryProps {
  template: ITemplate;
  holder: TemplateHolder;
}

function mouseIsInside(element: Element, x: number, y: number) {
  const box = element.getBoundingClientRect() as DOMRect;
  if (x < box.x || y < box.y) return false;
  if (x > (box.x + box.width)) return false;
  return y < (box.y + box.height);
}

class TemplateEntry extends React.Component<ITemplateEntryProps> {
  constructor(props: any, context: any) {
    super(props, context);
    this.onDragEnd = this.onDragEnd.bind(this);
  }
  public onDragEnd(event: React.DragEvent<any>) {
    TEMPLATE_DROPZONES.forEach((dropzone) => {
      const element = findDOMNode(dropzone) as Element;
      if (mouseIsInside(element, event.clientX, event.clientY)) {
        const template = this.props.template;
        dropzone.addTemplate(template);
      }
    });
  }
  public getError() {
    const temp = this.props.template;
    if (!temp.mimeType) return 'Invalid mime type';
    if ('buffer' in temp) {
      if (!temp.buffer.byteLength) return 'Empty file';
    } else if ('url' in temp) {
      if (!temp.url) return 'Empty url';
    } else {
      return 'No buffer or url present';
    }
    return null;
  }
  public render() {
    const temp = this.props.template;
    let content: JSX.Element;
    let error!: string | undefined;

    if (!temp.mimeType) {
      error = 'Unknown mime type';
    }

    if ('buffer' in temp) {
      content = <React.Fragment>
        <button className="download info" onClick={this.download}><FontAwesomeIcon icon="download" /> Download</button>
        <p>
        <b>{this.props.template.filename || <i>Unnamed</i>}</b>{' '}
        ({Math.floor(temp.buffer.byteLength / 1024)}kb, {temp.mimeType || <i>Unknown</i>})
        {error && <b className="error">{error}</b>}
      </p>
      </React.Fragment>
    } else if ('url' in temp) {
      content = <p>
        <b>{this.props.template.filename || <i>Unnamed</i>}</b>{' '}
        ({temp.mimeType || <i>Unknown</i>})
        {error && <b className="error">{error}</b>}
        <br/><a href={temp.url} target='_blank'>{temp.url}</a>
      </p>;
    } else {
      error = 'No idea what kind of file this is';
      content = <p><b className="error">{error}</b></p>
    }

    return (
      <li
        className={`TemplateEntry ${error ? 'error' : ''}`}
        draggable={true}
        onDragEnd={this.onDragEnd}
      >
        <button className="delete" onClick={this.delete}><FontAwesomeIcon icon="minus"/></button>
        {content}
      </li>
    )
  }
  protected delete = () => this.props.holder.remove(this.props.template.filename);
  protected download = () => downloadTemplate(this.props.template);
}

export default TemplateEntry;



// WEBPACK FOOTER //
// ./src/TemplateEntry/index.tsx